// The browser's entry, beside the document that loads it.
//
// It sits here rather than at `src/main.client.tsx`, next to the server's
// own entries, for one practical reason and one honest one. The practical
// one: Vite's root is this directory, and a module above it is outside the
// served tree — the production build resolved it on disk and the dev server
// could not, so the application built and would not run.
//
// The honest one: `index.html` and this file are ONE entry, the browser's.
// The two node entries beside each other at `src/` are the other two
// processes. Splitting a single entry across two directories to make a list
// look symmetrical is what caused the first problem.

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider, createQueryClient } from "@/platform/client";
import { App } from "@/shell";
import "@/platform/ui/index.css";

const queryClient = createQueryClient();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
